// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__ibNI2","buffered":"section_buffered__23V8W","full":"section_full__N5aQN"};